import { createContext } from 'react'
import type { ILoanProduct } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/types'

export const ProductInfoContext = createContext<ILoanProduct | undefined>(undefined)
